import { render, staticRenderFns } from "./commodityEdit.vue?vue&type=template&id=3b8dd784&scoped=true&"
import script from "./commodityEdit.vue?vue&type=script&lang=ts&"
export * from "./commodityEdit.vue?vue&type=script&lang=ts&"
import style0 from "./commodityEdit.vue?vue&type=style&index=0&id=3b8dd784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8dd784",
  null
  
)

export default component.exports